import { render } from "./ButtonTag.vue?vue&type=template&id=52691338"
import script from "./ButtonTag.vue?vue&type=script&lang=js"
export * from "./ButtonTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__